<template>
    <div class="workNotice">
            <Navbar title="作业通知" :backNative="true"  />
  <van-pull-refresh v-model="refreshing" style="min-height: 100vh;" @refresh="onRefresh">
                <van-list
                v-model="loading"
                :finished="finished"
                  :immediate-check='false'
                finished-text="没有更多了"
                @load="onLoad"
              >
            <div class="work_content">
                 <div class="work_card" v-for="(item,index) in list" :key="index" @click="toDetail(item)">
                     <div class="icon">
                         <img :src="item.workStatus==1?require('../../assets/images/good.png'):require('../../assets/images/bad.png')" alt="">
                     </div>
                     <div class="card_right">
                         <div class="title">{{item.workStatus==1?'恭喜你！你的作业已通过':'很遗憾！你的作业未通过'}}</div>

                         <div class="courseInfo">{{item.classGradeName}}</div>

                         <div class="time">{{item.releaseTime}}</div>
                     </div>
                 </div>
            </div>
             </van-list>
         </van-pull-refresh>
    </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
export default {
  data(){
      return {
        size: 20,
      current: 1,
     list:[],
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      }
  },
  mounted(){
    //   this.initPage()
  },
  methods:{
            initPage(){
       this.init=true
    
       this.current=1
      //  this.list=[]
       this.getComments()
      


     },
        onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }

      this.getComments();
    },
        getComments() {
      let query = this.$route.query;
      http
        .getSysWorkNotice({
          type:2,
          size: this.size,
          current: this.current
        })
        .then(res => {
          console.log(res);
          setTimeout(() => {
            if (res.length > 0) {
              if (this.refreshing||this.current==1) {
                this.list = [...res];
                this.refreshing = false;
              } else {
                this.list = [...this.list, ...res];
              }
              this.loading = false;
            } else {
              this.finished = true;
              this.current--;
             
            }
          }, 500);
         
         
        });
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current = 1;
      this.onLoad();
    },
    toDetail(item){
        this.$router.push({
            path:'/workDetail',
            query: { id:item.dataId,type:item.classType,isPass:item.workStatus,isSelf:true}
        })
        http.getMessege({id:item.id})
    }
  },
  components:{
      Navbar,
  },
}
</script>

<style lang="less" scoped>
 .workNotice{
     .work_content{
         width: calc(100% - 16px);
        margin-left: 16px;
         .work_card{
             display: flex;
             margin-top: 16px;
             .icon{
                 width: 40px;
                 height: 40px;
                 img{
                     width: 40px;
                     height: 40px;
                 }
             }
             .card_right{
                 flex:1;
                 margin-left: 12px;
                  border-bottom: 1px solid rgba(34,32,48,0.10);
                  padding-bottom: 16px;
                  .title{
                      font-size: 15px;
                      color: #222030;   
                  }
                  .courseInfo{
                      font-size: 13px;
                      margin-top: 4px;
                      color: rgba(34,32,48,0.45);
                  }
                  .time{
                      font-size: 11px;
                      color: rgba(34,32,48,0.25);
                      margin-top: 11px;
                  }
             }
         }
     }
 }
</style>

